/**
 * Acciones para estado de documento en la gestión de usuarios para el rol supervisor
 * gu_ed_ = Gestión de Usuario (gu) _ estados de documento (ed)
 */
import {Dispatch} from 'react'
import * as http from '../../../api/http'
import {ENDPOINTS} from '../../../api/config'
import {State} from '../../../reducers'
import {
  generalOpenModalError,
  generalOpenModalInfo,
  generalOpenModalMessage,
  generalShowLoader,
} from '../../general.actions'
import {GESTION_USUARIO_TYPES} from '../../../constants/gestionUsuario.types'
import {GestionUsuarioAction} from '../../../interfaces/gestion-usuarios.interace'
import {
  validacionesHandleChangeDocSucursal,
  validacionesHandleChangeDocumento,
  validacionesHandleChangeFacturador,
  validacionesHandleChangeSucursal,
  validacionesOnBlurDocumento,
  validacionesOnBlurDocumentoSucursal,
  validacionesOnBlurSucursal,
} from '../gu-generales/gu-generales'
import {KEYS} from '../../../constants/keysStorage'

// ******************************************************************************************
export const gu_ed_setArrayOriginal = (documentos: Array<any>) => ({
  type: GESTION_USUARIO_TYPES.ED_SET_ARRAY_ORIGINAL,
  payload: documentos,
})

export const gu_ed_setArrayFiltrador = (documentos: Array<any>) => ({
  type: GESTION_USUARIO_TYPES.ED_SET_ARRAY_FILTRADO,
  payload: documentos,
})

export const gu_ed_HandleChangeFormBuscar = (form: any) => ({
  type: GESTION_USUARIO_TYPES.ED_FORM_BUSCAR,
  payload: form,
})

export const gu_ed_ClearFormBuscar = () => ({
  type: GESTION_USUARIO_TYPES.ED_CLEAR_FORM_BUSCAR,
  payload: null,
})

export const gu_ed_Clear = () => ({
  type: GESTION_USUARIO_TYPES.ED_CLEAR,
  payload: null,
})

export const gu_ed_HandleChangeFormCrear = (form: any) => ({
  type: GESTION_USUARIO_TYPES.ED_FORM_CREAR,
  payload: form,
})

export const gu_ed_AddErrorFormCrear = (errors: any) => ({
  type: GESTION_USUARIO_TYPES.ED_FORM_CREAR_ADD_ERROR,
  payload: errors,
})

export const gu_ed_ClearFormCrear = () => ({
  type: GESTION_USUARIO_TYPES.ED_CLEAR_FORM_CREAR,
  payload: null,
})

export const gu_ed_ShowModalCrearEditarDocumento = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.ED_SHOW_MODAL_CREAR_EDITAR,
  payload: flag,
})

export const gu_ed_ShowModalCrearEditarSucursalDocumento = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.ED_SHOW_MODAL_DOC_CREAR_EDITAR,
  payload: flag,
})

export const gu_ed_ShowModalEliminarDocumento = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.ED_SHOW_MODAL_ELIMINAR,
  payload: flag,
})

export const gu_ed_ShowModalChangeEstatus = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.ED_SHOW_MODAL_CHANGE_ESTATUS,
  payload: flag,
})

export const gu_ed_SetDocumentoSeleccionado = (documento: any) => ({
  type: GESTION_USUARIO_TYPES.ED_SET_DOCUMENTOSELECCIONADO,
  payload: documento,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const gu_ed_FormBuscarHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>) => {
    let {name, value} = e.target
    if (!validacionesHandleChangeFacturador(name, value)) return
    dispatch(gu_ed_HandleChangeFormBuscar({[name]: value}))
  }

export const gu_ed_FormCrearHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>) => {
    let {name, value} = e.target
    if (!validacionesHandleChangeDocumento(name, value)) return
    dispatch(gu_ed_HandleChangeFormCrear({[name]: value}))
  }

// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
export const gu_ed_GetEstadosDocumento =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    await getEstadosDocumento(dispatch)
    dispatch(generalShowLoader(false))
  }

const getEstadosDocumento = async (dispatch: Dispatch<GestionUsuarioAction>, msg: string = '') => {
  let message = msg || 'No se logró obtener información de los estados de documento.'
  await http
    .get(ENDPOINTS.GESTION_USUARIO_GET_ESTADOS_DOCUMENTO)
    .then(async (res: any) => {
      dispatch(gu_ed_ClearFormBuscar())
      if (res?.data && Array.isArray(res.data)) {
        if (res.data.length > 0) {
          dispatch(gu_ed_setArrayOriginal(res.data))
          dispatch(gu_ed_setArrayFiltrador(res.data))
        } else {
          dispatch(gu_ed_setArrayOriginal([]))
          dispatch(gu_ed_setArrayFiltrador([]))
          dispatch(generalOpenModalInfo('No existen documentos registrados'))
        }
        return
      }
      dispatch(gu_ed_setArrayOriginal([]))
      dispatch(gu_ed_setArrayFiltrador([]))
      await dispatch(generalOpenModalError(message))
    })
    .catch(async (err: any) => {
      dispatch(gu_ed_setArrayOriginal([]))
      dispatch(gu_ed_setArrayFiltrador([]))
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
    })
}

export const gu_ed_BuscarEstadoDocumento =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    let arrayDocs = getState().gestionUsuario.estadoDocumentos.arrayOriginalDocumentos

    if (arrayDocs.length === 0 && !flag)
      return dispatch(generalOpenModalError('No se encontraron los documentos del usuario'))

    const {username} = getState().gestionUsuario.estadoDocumentos.formBuscar

    if (!username) return dispatch(gu_ed_setArrayFiltrador(arrayDocs))
    let message = 'No se obtuvieron resultados de la búsqueda de documentos del usuario.'
    await dispatch(generalShowLoader(true))
    await http
      .get(ENDPOINTS.GESTION_USUARIO_GET_DOCUMENTS_POR_USUARIO, {username})
      .then(async (res: any) => {
        if (res?.data) {
          if (res?.data?.UsuarioSucursals && Array.isArray(res.data.UsuarioSucursals)) {
            let documentos: Array<any> = []
            res.data.UsuarioSucursals.forEach((element: any) => {
              if (
                element?.Sucursal?.SucursalDocumentos &&
                Array.isArray(element.Sucursal.SucursalDocumentos)
              ) {
                let docs = element.Sucursal.SucursalDocumentos.map((el: any) => ({
                  iddocumento: el?.Documento?.iddocume,
                  nombre: el?.Documento?.nombre,
                  descripcion: el?.Documento?.descripc,
                  serie: el?.Documento?.serie,
                  codigodocumento: el?.Documento?.codigodo,
                }))
                documentos = documentos.concat(docs)
              }
            })
            dispatch(gu_ed_setArrayFiltrador(documentos))
          } else {
            dispatch(gu_ed_setArrayFiltrador([]))
            dispatch(generalOpenModalInfo('No existen documentos registrados'))
          }
          return
        }
        dispatch(gu_ed_setArrayFiltrador([]))
        await dispatch(generalOpenModalError(message))
      })
      .catch(async (err: any) => {
        dispatch(gu_ed_setArrayFiltrador([]))
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_ed_CrearDocumento =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const form = getState().gestionUsuario.estadoDocumentos.formCrear
    const body = {
      nombre: form.nombre.trim(),
      descripcion: form.descripcion.trim(),
      serie: form.serie.trim(),
      codigodocumento: form.codigo.trim(),
    }
    let message = 'Existió un error al crear el documento, inténtelo nuevamente'

    await http
      .post(ENDPOINTS.GESTION_USUARIO_POST_CREAR_DOCUMENTO, body)
      .then(async (res: any) => {
        if (res?.data) {
          let message = 'Existió un inconveniente al actualizar la tabla de documentos.'
          await getEstadosDocumento(dispatch, message)
          dispatch(gu_ed_ShowModalCrearEditarDocumento(false))
          dispatch(
            generalOpenModalMessage(`Documento Creado`, `El Documento ha sido creado exitosamente.`)
          )
          return
        }
        await dispatch(generalOpenModalError(res?.message ?? message))
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_ed_ActualizarDocumento =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const {formCrear, documentoSeleccionado} = getState().gestionUsuario.estadoDocumentos
    const body = {
      nombre: formCrear.nombre.trim(),
      descripcion: formCrear.descripcion.trim(),
      serie: documentoSeleccionado?.serie,
      codigodocumento: documentoSeleccionado?.codigodocumento,
      iddocumento: documentoSeleccionado?.iddocumento,
    }
    let message = 'Existió un error al editar el documento, inténtelo nuevamente'

    await http
      .post(ENDPOINTS.GESTION_USUARIO_POST_UPDATE_DOCUMENTO, body)
      .then(async (res: any) => {
        if (res?.data) {
          let message = 'Existió un inconveniente al actualizar la tabla de documentos.'
          await getEstadosDocumento(dispatch, message)
          dispatch(gu_ed_ShowModalCrearEditarDocumento(false))
          dispatch(
            generalOpenModalMessage(
              `Documento actualizado`,
              `El Documento ha sido modificado exitosamente.`
            )
          )
          return
        }
        await dispatch(generalOpenModalError(res?.message ?? message))
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_ed_EliminarDocumento =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const {documentoSeleccionado} = getState().gestionUsuario.estadoDocumentos
    const body = {
      admin_id: String(localStorage.getItem(KEYS.ID_CLIENT)), // ID Supervisor
      iddocumento: documentoSeleccionado?.iddocumento,
    }
    let message = 'Existió un error al editar el documento, inténtelo nuevamente'

    await http
      ._delete(ENDPOINTS.GESTION_USUARIO_DELETE_DOCUMENTO, body)
      .then(async (res: any) => {
        if (res?.status === 200) {
          let message = 'Existió un inconveniente al actualizar la tabla de documentos.'
          await getEstadosDocumento(dispatch, message)
          dispatch(gu_ed_ShowModalEliminarDocumento(false))
          dispatch(
            generalOpenModalMessage(
              `Documento Eliminado`,
              `El Documento ha sido eliminado exitosamente.`
            )
          )
          return
        }
        await dispatch(generalOpenModalError(res?.message ?? message))
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************

export const gu_ed_validacionesFormCrearOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {name, value} = e.target
    let message = validacionesOnBlurDocumento(name, value)
    dispatch(gu_ed_AddErrorFormCrear({[name]: message}))
  }

export const gu_ed_validacionesCrearConfirm =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formCrear, formCrearError} = getState().gestionUsuario.estadoDocumentos
    let errors = {...formCrearError}
    errors.nombre = validacionesOnBlurDocumento('nombre', formCrear.nombre)
    errors.serie = validacionesOnBlurDocumento('serie', formCrear.serie)
    errors.codigo = validacionesOnBlurDocumento('codigo', formCrear.codigo)
    errors.descripcion = validacionesOnBlurDocumento('descripcion', formCrear.descripcion)

    dispatch(gu_ed_AddErrorFormCrear(errors))
    if (errors.nombre || errors.serie || errors.codigo || errors.descripcion) return true
    return false
  }

  // ******************************************************************************************
// ? SUCURSALES
// ******************************************************************************************
export const su_setSucursalesList = (sucursales: Array<any>) => ({
  type: GESTION_USUARIO_TYPES.SU_SUCURALES_LIST,
  payload: sucursales,
})

export const su_setDocumentosSucursalesList = (documentos: Array<any>) => ({
  type: GESTION_USUARIO_TYPES.SU_DOCUMENTOS_SUCURALES_LIST,
  payload: documentos,
})

export const su_ClearFormSucursal = () => ({
  type: GESTION_USUARIO_TYPES.SU_CLEAR_FORM_SUCURSAL,
  payload: null,
})

export const su_setFormSucursal = (form: any) => ({
  type: GESTION_USUARIO_TYPES.SU_SET_FORM_SUCURSAL,
  payload: form,
})

export const su_setErrorsFormSucursal = (errors: any) => ({
  type: GESTION_USUARIO_TYPES.SU_SET_ERRORS_FORM_SUCURSAL,
  payload: errors,
})

export const su_FormSucursalHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>) => {
    let {name, value} = e.target
    if (!validacionesHandleChangeSucursal(name, value)) return
    dispatch(su_setFormSucursal({[name]: value}))
  }

export const su_validacionesCrearSucursal =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formSucursal, errorsSucursal} = getState().gestionUsuario.sucursales
    let errors = {...errorsSucursal}

    errors.nombre = validacionesOnBlurSucursal('nombre', formSucursal.nombre)
    errors.direccion = validacionesOnBlurSucursal('direccion', formSucursal.direccion)
    errors.descripcion = validacionesOnBlurSucursal('descripcion', formSucursal.descripcion)
    errors.codigo = validacionesOnBlurSucursal('codigo', formSucursal.codigo)

    dispatch(su_setErrorsFormSucursal(errors));
    if (errors.nombre || errors.direccion || errors.descripcion || errors.codigo) return true
    return false
  }

export const su_crearSucursal =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formSucursal} = getState().gestionUsuario.sucursales
      
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
  
    await http
      .post(ENDPOINTS.GESTION_SET_NEW_SUCURSALES, {
        codigoempresa: localStorage.getItem(KEYS.CODIGO_EMPRESA),
        username: localStorage.getItem(KEYS.USERNAME_CLIENTE),
        nombre: formSucursal.nombre.trim(),
        direccion: formSucursal.direccion.trim(),
        descripcion: formSucursal.descripcion.trim(),
        codigo: formSucursal.codigo.trim(),
      })
      .then(async (res: any) => {
        if (res.data) {
          dispatch(
            generalOpenModalMessage(
              `Sucursal agregada`,
              `La sucursal ha sido creada exitosamente.`
            )
          )
          dispatch(gu_ed_ShowModalCrearEditarDocumento(false));
          dispatch(su_ClearFormSucursal());
          return true;
        } else {
          await dispatch(generalOpenModalError(res.message ?? 'Error al crear la nueva sucursal'))
          return false;
        }
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Error al crear la sucursal', err?.response?.data?.status))
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
    }

export const su_editarSucursal =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formSucursal, dataSucursales} = getState().gestionUsuario.sucursales
      
    if (dataSucursales.find(suc => suc.nombre === formSucursal.nombre && suc.idsucursal !== formSucursal.idsucursal)) {
      await dispatch(generalOpenModalError('El nombre de la sucursal ya existe'))
      return;
    }
  
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    await http
      .put(ENDPOINTS.GESTION_SET_EDIT_SUCURSALES, {
        idsucursal: formSucursal.idsucursal,
        username: localStorage.getItem(KEYS.USERNAME_CLIENTE),
        nombre: formSucursal.nombre.trim(),
        direccion: formSucursal.direccion.trim(),
        descripcion: formSucursal.descripcion.trim(),
        codigo: formSucursal.codigo.trim(),
      })
      .then(async (res: any) => {
        if (res.data) {
          dispatch(
            generalOpenModalMessage(
              `Sucursal editada`,
              `La sucursal ha sido editada exitosamente.`
            )
          )
          dispatch(gu_ed_ShowModalCrearEditarDocumento(false));
          dispatch(su_ClearFormSucursal());
          return true;
        } else {
          await dispatch(generalOpenModalError(res.message ?? 'Error al editar la sucursal'))
          return false;
        }
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Error al editar la sucursal', err?.response?.data?.status))
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
    }
    
export const su_getSucursalesList =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
   
    await http
      .get(ENDPOINTS.GESTION_GET_SUCURSALES, {codigoempresa: localStorage.getItem(KEYS.CODIGO_EMPRESA)})
      .then(async (res: any) => {
        if (res.data) {
          dispatch(su_setSucursalesList(res.data));
        } else {
          await dispatch(generalOpenModalError(res.message ?? 'No hay sucursales disponibles'))
        }
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Error al obtener las sucursales', err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const su_eliminarSucursal =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {documentoSeleccionado} = getState().gestionUsuario.estadoDocumentos
    let {dataSucursales, dataDocumentos} = getState().gestionUsuario.sucursales

    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    
    await http
      ._delete(ENDPOINTS.GESTION_SET_DELETE_SUCURSALES, {
        idsucursal: documentoSeleccionado?.idsucursal
      })
      .then(async (res: any) => {
        if (res.data) {
          dispatch(
            generalOpenModalMessage(
              `Sucursal eliminada`,
              `La sucursal y sus documentos asociados han sido eliminados exitosamente.`
            )
          )

          dispatch(su_setSucursalesList(dataSucursales.filter(doc => doc.idsucursal !== documentoSeleccionado?.idsucursal)));
          dispatch(su_setDocumentosSucursalesList(dataDocumentos.filter(doc => doc.idsucursal !== documentoSeleccionado?.idsucursal)));
          dispatch(gu_ed_ShowModalEliminarDocumento(false))
          return true;
        } else {
          await dispatch(generalOpenModalError(res.message ?? 'Error al eliminar la sucursal'))
          return false;
        }
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? "Error al eliminar la sucursal", err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const su_cambiarEstatusSucursal =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {documentoSeleccionado} = getState().gestionUsuario.estadoDocumentos
    let {dataSucursales,dataDocumentos} = getState().gestionUsuario.sucursales

    await dispatch(generalShowLoader(true))
    await http
      .put(ENDPOINTS.GESTION_SET_ACTIVE_SUCURSALES, {
        idsucursal: documentoSeleccionado?.idsucursal,
        active: documentoSeleccionado?.accion,
      })
      .then(async (res: any) => {
        if (res.data) {
          dispatch(
            generalOpenModalMessage(
              `Sucursal ${documentoSeleccionado?.accion ? 'activada' : 'desactivada'}`,
              `El cambio de estatus ha sido exitoso.`
            )
          )
          dispatch(su_setSucursalesList(dataSucursales.map(suc => {
            if (suc.idsucursal === documentoSeleccionado?.idsucursal) return {...suc, activo: documentoSeleccionado?.accion}
            return suc
          })));
          dispatch(su_setDocumentosSucursalesList(dataDocumentos.map(doc => {
            if (doc.idsucursal === documentoSeleccionado?.idsucursal) return {...doc, estado: documentoSeleccionado?.accion}
            return doc
          })));
          dispatch(gu_ed_ShowModalChangeEstatus(false))
          return true;
        } else {
          await dispatch(generalOpenModalError(res.message ?? 'Error al cambiar el estatus de la sucursal'))
          return false;
        }
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? "Error al cambiar el estatus de la sucursal", err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }
  

  // ******************************************************************************************
// ? DOCUMENTOS DE SUCURSALES
// ******************************************************************************************
export const su_setFormDocSucursal = (form: any) => ({
  type: GESTION_USUARIO_TYPES.SU_SET_FORM_DOC_SUCURSAL,
  payload: form,
})

export const su_setErrorsFormDocSucursal = (errors: any) => ({
  type: GESTION_USUARIO_TYPES.SU_SET_ERRORS_FORM_DOC_SUCURSAL,
  payload: errors,
})

export const su_ClearFormDocSucursal = () => ({
  type: GESTION_USUARIO_TYPES.SU_CLEAR_FORM_DOC_SUCURSAL,
  payload: null,
})

export const su_FormDocSucursalHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>) => {
    let {name, value} = e.target
    let valuePr = validacionesHandleChangeDocSucursal(name, value);

    if (valuePr === undefined) return;
    dispatch(su_setFormDocSucursal({[name]: valuePr}))
  }

export const su_getDocumentosSucursalesList =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    await dispatch(generalShowLoader(true))
    await http
      .get(ENDPOINTS.GESTION_SUCURSALES_DOCUMENTOS, {codigoempresa: localStorage.getItem(KEYS.CODIGO_EMPRESA)})
      .then(async (res: any) => {
        if (res.data) {
          dispatch(su_setDocumentosSucursalesList(res.data));
        }
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Error al obtener los documentos', err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

  export const su_validacionesCrearDocumentoSucursal =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formDocumento, errorsDocumento} = getState().gestionUsuario.sucursales
    let errors = {...errorsDocumento}

    errors.documento = validacionesOnBlurDocumentoSucursal('documento', formDocumento.documento)
    errors.idsucursal = validacionesOnBlurDocumentoSucursal('idsucursal', formDocumento.idsucursal)
    errors.resolucion = validacionesOnBlurDocumentoSucursal('resolucion', formDocumento.resolucion)
    errors.numeroSucursal = validacionesOnBlurDocumentoSucursal('numeroSucursal', formDocumento.numeroSucursal)

    if (parseInt(formDocumento.correlativoInicial) > parseInt(formDocumento.correlativoFinal)) {
      errors.correlativoInicial = 'Correlativo inicial invalido, es mayor que el correlativo final';
    }

    dispatch(su_setErrorsFormDocSucursal(errors));
    if (errors.documento || errors.idsucursal || errors.numeroSucursal || errors.resolucion) return true
    return false
  }

export const su_crearDocumento =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formDocumento} = getState().gestionUsuario.sucursales
      
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
  
    await http
      .post(ENDPOINTS.GESTION_SUCURSALES_DOCUMENTOS, {
        idsucursal: formDocumento.idsucursal,
        iddocumento: formDocumento.documento,
        serie: formDocumento.codigoSucursal + formDocumento.numeroSucursal.trim(),
        numeroinicial: "1".padStart(15, '0'),
        numerofinal: "9".padStart(15, '9'),
        resolucion: formDocumento.resolucion.trim(),
      })
      .then(async (res: any) => {
        if (res.data) {
          dispatch(
            generalOpenModalMessage(
              `Documento agregado`,
              `El nuevo documento ha sido creado exitosamente y ya se encuentra disponible en la sucursal correspondiente.`
            )
          )
          dispatch(gu_ed_ShowModalCrearEditarSucursalDocumento(false));
          dispatch(su_ClearFormSucursal());
          return true;
        } else {
          await dispatch(generalOpenModalError(res.message ?? 'Error al crear el documento'))
          return false;
        }
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Error al crear el documento', err?.response?.data?.status))
        return false;
      })
      .finally(() => dispatch(generalShowLoader(false)))
    }

export const su_editarDocumento =
() => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
  let {formDocumento} = getState().gestionUsuario.sucursales
  let {documentoSeleccionado} = getState().gestionUsuario.estadoDocumentos

  if (getState().general.loader) return
  await dispatch(generalShowLoader(true))

  await http
    .put(ENDPOINTS.GESTION_SUCURSALES_DOCUMENTOS, {
      idsucursaldocumento: documentoSeleccionado.idsucursaldocumento,
      idsucursal: formDocumento.idsucursal,
      iddocumento: formDocumento.documento,
      serie: formDocumento.codigoSucursal + formDocumento.numeroSucursal.trim(),
      numeroinicial: "1".padStart(15, '0'),
      numerofinal: "9".padStart(15, '9'),
      resolucion: formDocumento.resolucion.trim(),
    })
    .then(async (res: any) => {
      if (res.data) {
        dispatch(
          generalOpenModalMessage(
            `Documento editado`,
            `El documento ha sido editado exitosamente.`
          )
        )
        dispatch(gu_ed_ShowModalCrearEditarSucursalDocumento(false));
        dispatch(su_ClearFormSucursal());
        return true;
      } else {
        await dispatch(generalOpenModalError(res.message ?? 'Error al crear el documento'))
        return false;
      }
    })
    .catch(async (err) => {
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Error al crear el documento', err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
  }
    
export const su_eliminarDocumento =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {documentoSeleccionado} = getState().gestionUsuario.estadoDocumentos
    let {dataDocumentos} = getState().gestionUsuario.sucursales

    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    
    await http
      ._delete(ENDPOINTS.GESTION_SUCURSALES_DOCUMENTOS, {
        idsucursaldocumento: documentoSeleccionado?.idsucursaldocumento
      })
      .then(async (res: any) => {
        if (res.data) {
          dispatch(
            generalOpenModalMessage(
              `Documento eliminado`,
              `El documento ha sido eliminado exitosamente.`
            )
          )
          dispatch(su_setDocumentosSucursalesList(dataDocumentos.filter(doc => doc.idsucursaldocumento !== documentoSeleccionado?.idsucursaldocumento)));
          dispatch(gu_ed_ShowModalEliminarDocumento(false))
          return true;
        } else {
          await dispatch(generalOpenModalError(res.message ?? 'Error al eliminar el documento'))
          return false;
        }
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? "Error al eliminar el documento", err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }
  
export const su_cambiarEstatusDocumento =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {documentoSeleccionado} = getState().gestionUsuario.estadoDocumentos
    let {dataDocumentos} = getState().gestionUsuario.sucursales

    await dispatch(generalShowLoader(true))
    await http
      .put(ENDPOINTS.GESTION_SET_ACTIVE_SUCURSALES_DOCUMENTOS, {
        idsucursaldocumento: documentoSeleccionado?.idsucursaldocumento,
        active: documentoSeleccionado?.accion,
      })
      .then(async (res: any) => {
        if (res.data) {
          dispatch(
            generalOpenModalMessage(
              `Documento ${documentoSeleccionado?.accion ? 'activado' : 'desactivado'}`,
              documentoSeleccionado?.accion ? 'El documento ya se encuentra disponible para realizar operaciones' : 'El documento ya no se encuentra disponible para realizar operaciones',
            )
          )

          dispatch(su_setDocumentosSucursalesList(dataDocumentos.map(suc => {
            if (suc.idsucursaldocumento === documentoSeleccionado?.idsucursaldocumento) return {...suc, estado: documentoSeleccionado?.accion}
            return suc
          })));
          dispatch(gu_ed_ShowModalChangeEstatus(false))
          return true;
        } else {
          await dispatch(generalOpenModalError(res.message ?? 'Error al cambiar el estatus del documento'))
          return false;
        }
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? "Error al cambiar el estatus del documento", err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }